import { OsType } from 'mbs-ui-shared@models/Computer';
import { ConnectionType } from 'mbs-ui-shared@models/ConnectionType';
import { AwsSetPayload } from 'mbs-ui-shared@models/login';
import { PerPageSize } from './Paging';

export class AppPersistentState {
  supportMessages: { date: number; count: number } = null;
  shownTemplateButton = false;
  isFirstVisitComputersPage = true;
  isFirstVisitRDPage = false;
  showUnsupportedVersionsMessage = true;
  showRdLicenseNotGranted = true;
  showUnconfiguredEmailNotifications = true;
  showBackupHistoryFullBackupFilterTooltip = true;
  timeZoneAlertDismissed = false;
  betaMode = {
    rmm: false
  };

  rmmSidepanel = {
    updateInterval: 10,
    agentOptions: null
  };

  /**
   * Key is storageId
   * For right behavior override refs
   */
  showUbMessage: { [key: string]: boolean } = {};
  showAlertAboutBounceList = true;
  showNotificationForcedTFA = true;
  lastSignIn = new Date();
  userId = '';
  signUpDate: Date = null;
  feedbackRemindLateDate = null;
  administratorsPerPage = PerPageSize.Large;
  computersPerPage = PerPageSize.Large;
  scheduledReportsPerPage = PerPageSize.Large;
  companiesPerPage = PerPageSize.Medium;
  licensesPerPage = PerPageSize.Medium;
  licensesUsageHistoryPerPage = PerPageSize.Medium;
  customDnsBindingPerPage = PerPageSize.Large;
  auditLogPerPage = PerPageSize.Medium;
  monitoringPerPage = PerPageSize.Large;
  notificationErrorsPerPage = PerPageSize.Large;
  usersPerPage = PerPageSize.Medium;
  domainsPerPage = PerPageSize.Large;
  backupHistoryPerPage = PerPageSize.Large;
  destinationsPerPage = PerPageSize.Medium;
  storagesPerPage = PerPageSize.Medium;
  purchaseHistoryPerPage = PerPageSize.Large;
  licensesColumnsForShow = undefined;
  showApplicationInstallBanner = true;
  selectedConnectionType: Partial<{ [key in OsType]: ConnectionType }> = {};
  isRefusedTFA = false;
  awsSetPayload: AwsSetPayload = null;
}
